import Ajax from '@/lib/ajax'

export default {
  getList(pageSize: number, currentPage: number, sorting?: string) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      Sorting: sorting
    }
    return Ajax.get(`/api/MallConfigManagement/topic`, {
      params: params
    })
  },
  get(id: string) {
    return Ajax.get(`/api/MallConfigManagement/topic/${id}`)
  },
  create(data: any) {
    return Ajax.post(`/api/MallConfigManagement/topic`, data)
  },
  update(id: string, data: any) {
    return Ajax.put(`/api/MallConfigManagement/topic/${id}`, data)
  },
  deleteItem(id: string) {
    return Ajax.delete(`/api/MallConfigManagement/topic/${id}`)
  }
}
